"use strict";

import {findAll, on, trigger} from "../libs/@elements/dom-utils";
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {getLoadingContainer} from "./loading-spinner";

export function init () {
    onFind('.js-submit-form__btn', function (inputElement) {
        window.addEventListener('pagehide', (event) => {
            removeLoadingIndicator(inputElement)
        });
        const changeHandler = (evt, input) => {
            let form = findAll('.js-submit-form', input);
            if (inputElement.style.position !== 'absolute' || 'relative') {
                inputElement.style.position = 'relative';
            }
            inputElement.classList.add('disabled');
            inputElement.innerHTML += getLoadingContainer();
            trigger('submit',form);
        };

        on('click', (evt) => changeHandler(evt, inputElement), inputElement);

    });
}

function removeLoadingIndicator(el) {
    const loadingContainer = el.getElementsByClassName('loading-overlay')
    if(loadingContainer[0]) {
        el.removeChild(loadingContainer[0])
    }
    el.classList.remove('disabled');
}
